import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/firestore'

var firebaseConfig = {
    apiKey: "AIzaSyC_pKBjPFM5UBvh4HGhu1KtGP21l4_LzNY",
    authDomain: "cocentric-5e0cc.firebaseapp.com",
    projectId: "cocentric-5e0cc",
    storageBucket: "cocentric-5e0cc.appspot.com",
    messagingSenderId: "1001238761819",
    appId: "1:1001238761819:web:6775bf044aa01e0ba48a7e",
    measurementId: "G-58R0T67HQE"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const auth = firebase.auth()
const firestore = firebase.firestore()

firebase.analytics();



export {auth,firestore,firebase}
